import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

// Note: this does not check against permissions when adding params
// If we ever have a scoped param route we'll need to ensure we check scope somewhere
export const useAddQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const addQueryParams = (params: Record<string, string>) => {
    const queryParams = new URLSearchParams(location.search);
    Object.entries(params).forEach(([key, value]) => {
      queryParams.set(key, value);
    });
    navigate({ search: queryParams.toString() });
  };

  return addQueryParams;
};
